import { render, staticRenderFns } from "./video_5.vue?vue&type=template&id=33081e60&scoped=true&"
var script = {}
import style0 from "./video_5.vue?vue&type=style&index=0&id=33081e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33081e60",
  null
  
)

export default component.exports